import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

import type { FaultedDevice } from '@/features/equipment-browser/faulted-devices/faulted-devices.types';

import type { ModeValuesByDeviceId } from '../reset-faulted.types';
import { createCurrentModesAtom } from '../state/current-modes.state';

/**
 * Live current mode of each device, read from its mode dropdown's value ref.
 * Re-renders when any of those settings change.
 */
export const useCurrentModes = (devices: FaultedDevice[]): ModeValuesByDeviceId => {
  const currentModesAtom = useMemo(() => createCurrentModesAtom(devices), [devices]);

  return useAtomValue(currentModesAtom);
};
